export function setHeightForFirstFullScreen() {
    const isIE = this.isIE;
    const _document = document;
    const _window = window;
    const isTouch = this.isTouch;
    const viewportSections = [].slice.call(_document.querySelectorAll(".full-screen-section"));
    const minViewportHeight = 568;

    function setViewportHeight() {
        let isPortraitOrientation = _window.innerWidth <= _window.innerHeight;
        let viewportHeight = isPortraitOrientation ? _window.innerHeight : minViewportHeight;

        if (_window.innerWidth >= 1200) {
            viewportHeight = _window.innerHeight;
        }

        viewportSections.forEach(element => {
            element.style.height = `${viewportHeight}px`;
        });
    }

    if (isTouch) {
        setViewportHeight();
        _window.addEventListener("orientationchange", () => {
            setTimeout(() => {
                setViewportHeight();
            }, 200);
        });
    }

    if (isIE() && this._body.classList.contains("home-template")) {
        setViewportHeight();
        _window.addEventListener("resize", () => {
            setTimeout(() => {
                setViewportHeight();
            }, 200);
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/full-screen-section-handler.js